import producer from "immer";

const INITIAL_STATE = {
	loading: false,
	valid_token_success: undefined,
	valid_token_error: undefined,
	failPinCodeAccount: false,
	respSendRegisterCelPhone: [],
	respResendPhoneConfirmation: [],
};

export default function confirmToken(state = INITIAL_STATE, action) {
	const ACTIONS = {
		"@confirmToken/CHANGE_LOADING": (draft) => {
			draft.loading = action.payload.loading;
		},
		"@confirmToken/VALIDATE_TOKEN_CONFIRM_PHONE_REQUEST": (draft) => {
			draft.loading = true;
		},
		"@confirmToken/SEND_TOKEN_REQUEST": (draft) => {
			draft.loading = true;
		},
		"@confirmToken/VALIDATE_TOKEN_CONFIRM_PHONE_SUCCESS": (draft) => {
			draft.valid_token_success = action.payload.data;
		},
		"@confirmToken/VALIDATE_TOKEN_CONFIRM_PHONE_ERROR": (draft) => {
			draft.valid_token_error = action.payload.data;
		},
		"@confirmToken/FAIL_PINCODE_NEW_ACCOUNT": (draft) => {
			draft.failPinCodeAccount = action.payload.param;
		},
		"@confirmToken/RESP_SEND_REGISTER_CEL_PHONE": (draft) => {
			draft.respSendRegisterCelPhone = action.payload.param;
		},
		"@confirmToken/RESP_RESEND_PHONE_CONFIRMATION": (draft) => {
			draft.respResendPhoneConfirmation = action.payload.param;
		},
	};

	return producer(state, (draft) => {
		return Object.keys(ACTIONS).indexOf(action.type) !== -1 ? ACTIONS[action.type](draft) : state;
	});
}
